import { Route, Routes } from 'react-router-dom'

import { fetchMeta } from '@/api'
import { PageShell } from '@/components/common'
import { Layout } from '@/components/Layout'
import { useAsync } from '@/hooks'
import { useI18n } from '@/i18n'
import { About } from '@/pages/About'
import { Glossary } from '@/pages/Glossary'
import { MatrixPage } from '@/pages/MatrixPage'
import { Overview } from '@/pages/Overview'
import { ProfileDetail } from '@/pages/ProfileDetail'
import { Profiles } from '@/pages/Profiles'
import { ResourceDetail } from '@/pages/ResourceDetail'
import { Resources } from '@/pages/Resources'
import { PrinciplesProvider } from '@/principles'

function NotFound() {
    const { t } = useI18n()
    return (
        <PageShell>
            <h1>{t('common.notFound')}</h1>
        </PageShell>
    )
}

export function App() {
    const meta = useAsync(fetchMeta, [])

    return (
        <PrinciplesProvider>
            <Routes>
                <Route element={<Layout meta={meta.data} />}>
                    <Route index element={<Overview />} />
                    <Route path="resources" element={<Resources />} />
                    <Route path="resources/:resourceId" element={<ResourceDetail />} />
                    <Route path="profiles" element={<Profiles />} />
                    <Route path="profiles/:fipId" element={<ProfileDetail />} />
                    <Route path="matrix" element={<MatrixPage />} />
                    <Route path="glossary" element={<Glossary />} />
                    <Route path="about" element={<About />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </PrinciplesProvider>
    )
}
